/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./BaseListItem.vue?vue&type=template&id=6d782cf0"
import script from "./BaseListItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseListItem.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BaseListItem.vue?vue&type=style&index=0&id=6d782cf0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports